import React, { Fragment, useContext, useEffect, useState } from 'react'
import WhatsappStatus from './WhatsappStatus'
import Workunit from './Workunit'
import CustomerServices from './CustomerServices'
import { AuthContext } from '../../../App/App'
import jwt from 'jwt-decode'
import WhatsappReadOnly from './WhatsappReadOnly'
import ComplaintTypeTable from './ComplaintTypeTable'
import ClientTypeTable from './ClientTypeTable'
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";

function Dashboard() {
    const { stateAuth } = useContext(AuthContext)
    const token = jwt(localStorage.getItem('token-helpdesk-umy'))

    return (
        <div className="main-content mb-5">
            <section className="section">
                <div className="section-header">
                    <h1>{stateAuth.page}</h1>
                </div>
                <div className="section-body col-12 p-0">
                    <div className="row ">
                        {token.role_id == 1 ? (
                            <Fragment>
                                <Workunit />
                                <CustomerServices />
                                <WhatsappStatus />
                            </Fragment>
                        ) : (token.role_id == 2 ? (
                            <Fragment>
                                <Workunit />
                                <WhatsappReadOnly />
                            </Fragment>
                        ) : <Fragment />)}
                    </div>
                </div>
            </section>
            <section>
                <PrimeReactProvider>
                    <div className="row col-12 m-0 p-0">
                        <div className="col-12 col-md-12 col-lg-7 m-0 p-0">
                            <ComplaintTypeTable />
                        </div>
                        <div className="col-12 col-md-12 col-lg-5 m-0 p-0">
                            <ClientTypeTable />
                        </div>
                    </div>
                </PrimeReactProvider>
            </section>
        </div>
    )
}

export default Dashboard
